import Field from "@/components/Field";
import { Input } from "@/components/ui/input";
import { memo } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const EverySecondWeekFieldComponent = () => {
  const { getValues } = useFormContext();
  const { t } = useTranslation();

  return (
    <Field
      name="every_second_week"
      className="flex-row-reverse justify-self-start"
      label={t("projectSchedules.fields.every_second_week")}
      render={({ field }) => (
        <Input
          className="h-4 w-4 "
          type="checkbox"
          {...field}
          checked={getValues("every_second_week")}
        />
      )}
    />
  );
};

export const EverySecondWeekField = memo(EverySecondWeekFieldComponent);
